import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { sumMoney, formatDisplayWeek, formatAmount, unapprovedWeekMap } from '../../helper';
import SectionHeader from '../../Pages/admin/shared/SectionHeader';
import TotalsBar from '../../Pages/admin/shared/TotalsBar';
import NotApprovedTag, { NotApprovedRange } from '../../Pages/admin/shared/NotApprovedTag';

class Detail extends Component {
    render() {
        const rows = this.props.ReportDetails || [];
        const totalPaid = sumMoney(rows, 'TOTAL_PAID');
        const totalOutstanding = sumMoney(rows, 'OUTSTANDING_BALANCE');
        // Weeks holding not-approved records, system-wide — a marker only (T1.35).
        const unapproved = unapprovedWeekMap(this.props.UnapprovedWeeks);
        return (
            <section>
                {/* ── Overview: one row per shop ── */}
                <SectionHeader title={<>Shop Payment Summary<NotApprovedRange weeks={this.props.UnapprovedWeeks} /></>} />

                <Row>
                    <Col md={12} >
                        <Paper>
                            <TableContainer className="report-table-container" >
                                <Table className="report-table pc-shrink-table" size="small" aria-label="shop payment summary table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ color: 'white' }} >Shop</TableCell>
                                            <TableCell style={{ color: 'white' }} align="right" >Total Paid (£)</TableCell>
                                            <TableCell style={{ color: 'white' }} align="right" >Outstanding Balance (£)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.length === 0 ?
                                            <TableRow>
                                                <TableCell colSpan={3} align="center" >No shop payments in this range.</TableCell>
                                            </TableRow>
                                            :
                                            rows.map((r, idx) => (
                                                <TableRow
                                                    className="table-rows"
                                                    key={idx}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell>{r.SHOP_NAME}</TableCell>
                                                    <TableCell align="right">{formatAmount(r.TOTAL_PAID)}</TableCell>
                                                    <TableCell align="right">{formatAmount(r.OUTSTANDING_BALANCE)}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                        <TableRow style={{ background: '#e7e7e7' }} >
                                            <TableCell style={{ fontWeight: "800" }} >Total</TableCell>
                                            <TableCell style={{ fontWeight: "800" }} align="right" >{formatAmount(totalPaid)}</TableCell>
                                            <TableCell style={{ fontWeight: "800" }} align="right" >{formatAmount(totalOutstanding)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Col>
                </Row>

                {/* ── Per-shop "Pay By Shop" breakdown ── */}
                {rows.map((shop, sIdx) => {
                    const entries = shop.entries || [];
                    const payByShop = sumMoney(entries, 'AMOUNT');
                    return (
                        <div key={sIdx} style={{ marginTop: 22 }} >
                            <SectionHeader title={<>{shop.SHOP_NAME} — Pay By Shop</>} />

                            <Row>
                                <Col md={12} >
                                    <Paper>
                                        <TableContainer className="report-table-container" >
                                            <Table className="report-table pc-shrink-table" size="small" aria-label="pay by shop breakdown">
                                                <TableHead>
                                                    <TableRow style={{ background: "#0b2e59" }} >
                                                        <TableCell style={{ color: 'white' }} >Week</TableCell>
                                                        <TableCell style={{ color: 'white' }} >Shop Name</TableCell>
                                                        <TableCell style={{ color: 'white' }} >Account Name</TableCell>
                                                        <TableCell style={{ color: 'white' }} >Description</TableCell>
                                                        <TableCell style={{ color: 'white' }} align="right" >Amount (£)</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {entries.length === 0 ?
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="center" >No payments in this range.</TableCell>
                                                        </TableRow>
                                                        :
                                                        entries.map((e, i) => (
                                                            <TableRow
                                                                className="table-rows"
                                                                key={i}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell className="report-label-cell" >{formatDisplayWeek(e.WK)}<NotApprovedTag info={unapproved.get(e.WK)} /></TableCell>
                                                                <TableCell>{shop.SHOP_NAME}</TableCell>
                                                                <TableCell>{e.RECIPIENT_NAME}</TableCell>
                                                                <TableCell>{e.DESCRIPTION}</TableCell>
                                                                <TableCell align="right">{formatAmount(e.AMOUNT)}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                    <TableRow style={{ background: '#e7e7e7' }} >
                                                        <TableCell colSpan={4} style={{ fontWeight: "800" }} >Pay By Shop</TableCell>
                                                        <TableCell style={{ fontWeight: "800" }} align="right" >{formatAmount(payByShop)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Col>
                            </Row>

                            <TotalsBar>
                                    <span>BALANCE B/F: </span>
                                    <span>£ {formatAmount(shop.OPENING_BALANCE)}</span>
                                    <span style={{ borderRight: '1px solid', margin: '0px 5px' }} ></span>
                                    <span>PAY BY SHOP: </span>
                                    <span>£ {formatAmount(payByShop)}</span>
                                    <span style={{ borderRight: '1px solid', margin: '0px 5px' }} ></span>
                                    <span style={{ fontWeight: 800 }} >OUTSTANDING BALANCE: </span>
                                    <span style={{ fontWeight: 800 }} >£ {formatAmount(shop.OUTSTANDING_BALANCE)}</span>
                                
                            </TotalsBar>
                        </div>
                    );
                })}
            </section>
        );
    }
}

export default Detail;
